import { useCallback } from "react";
import { ColumnHeader } from "./column-header";
import { HeaderProps } from "../types/header-props";
import { Sort } from "../types/sort";
import { SortDirection } from "../types/sort-direction";

interface TableHeadProps<TSort> {
    sort?: Sort<TSort>;
    setSort: (sort: Sort<TSort>) => void;
    columns?: HeaderProps<TSort>[];
    SortIcon?: React.FunctionComponent<{ isActive: boolean, direction: SortDirection }>
}

export function TableHead<TSort>({ sort, setSort, columns, SortIcon }: TableHeadProps<TSort>) {
    const { column, direction } = sort || {};

    const setColumn = useCallback((column: TSort) => {
        setSort({
            column,
            direction: 'asc'
        });
    }, [setSort]);

    const toggleDirection = useCallback(() => {
        if (!column || !direction) {
            return;
        }
        setSort({
            column: column,
            direction: direction === 'asc' ? 'desc' : 'asc'
        });
    }, [setSort, column, direction]);

    const headerSortControls = {
        column: column,
        direction: direction,
        setColumn: setColumn,
        toggleDirection: toggleDirection
    };

    return (<>
        {columns && columns.length &&
            <thead>
                <tr>
                    {columns.map((c, i) => <th style={{ verticalAlign: 'middle' }} key={i}>
                        <ColumnHeader SortIcon={SortIcon} column={c} sort={headerSortControls} />
                    </th>)}
                </tr>
            </thead>}
    </>);
}
